export const PRINTER_TYPE = {
    EPSON: 'epson',
    SUNMI: 'sunmi',
    BIXOLON: 'bixolon',
    CLOUDPRINT: 'cloudprint',
    WEBPRINT: 'WEBPRNT',
    QZ: 'QZ'
};

/**
 * Printer types handled by the native mobile app rather than the browser.
 * These are posted to the React Native webview; everything else goes through
 * window.printTicket (QZ / WebPRNT).
 */
export const NATIVE_APP_PRINTER_TYPES = [
    PRINTER_TYPE.EPSON,
    PRINTER_TYPE.SUNMI,
    PRINTER_TYPE.BIXOLON,
];